<template>
  <div>
    <v-text-field
      v-model="filters.search"
      :label="$t('DATA_TABLE.SEARCH')"
      outlined
      class="pt-5"
      append-icon="mdi-magnify"
      @input="refreshData"
    ></v-text-field>
  </div>
</template>

<script>
import { isEqual } from 'lodash';

export default {
  name: 'AppContentListFilter',

  components: {},

  props: {
    value: {
      type: Object,
      default: () => ({})
    }
  },

  data() {
    return {
      filters: {}
    };
  },

  watch: {
    value: {
      deep: true,
      immediate: true,
      handler: 'valueWatchHandler'
    }
  },

  created() {},

  methods: {
    valueWatchHandler(formProps) {
      if (isEqual(formProps, this.filters)) {
        return;
      }

      this.filters = {
        ...this.filters,
        ...formProps
      };
    },

    refreshData() {
      this.$emit('setRequest', { ...this.filters });
    }
  }
};
</script>
